import React from 'react';

import type { GalleryComponent } from '../../../../../../core/data-sources/content-components/types.js';

import Image from '../Image.js';
import FadeGallery from './FadeGallery.js';
import { HorizontalGallery } from './HorizontalGallery.js';

export interface GalleryProps {
  item: GalleryComponent;
  isMobile: boolean;
  articleTitle: string;
  groupIndex?: number;
}

const Gallery: React.FC<GalleryProps> = ({
  item,
  isMobile,
  articleTitle,
  groupIndex,
}) => {
  if (item.presentationProperties?.intention === 'vertical-fade') {
    return (
      <FadeGallery
        key={`fade-gallery-${groupIndex ?? ('caption' in item.components[0] && item.components[0].caption?.value)}`}
        {...item}
        layout={item.presentationProperties?.addLayout}
        isMobile={isMobile}
      />
    );
  }

  if (item.components.length <= 2) {
    return (
      <div>
        {item.components.map((i) => (
          <Image
            key={`image-${i.imageAsset.id}`}
            {...i}
            lazyLoad
            articleTitle={articleTitle}
          />
        ))}
      </div>
    );
  }

  return (
    <HorizontalGallery
      key={`gallery-${groupIndex}`}
      gallery={item}
      isMobile={isMobile}
      articleTitle={articleTitle}
    />
  );
};

export default Gallery;
